module.exports = __webpack_public_path__ + "img/28cfcb84fa05f417ea888fd948d0dbd0.png";